export default __webpack_public_path__ + "static/media/ss5.2d51a936.png";